import { resolveVueRouter } from '@/services/utils/modules/routerWrapper'
import store from '@/store'
const updateInner = (el, binding) => {
  el.style.color = '#3861ff'
  el.style.fontSize = '12px'
  el.style.cursor = 'pointer'
  if (binding.value.reviewId) {
    el.innerHTML = binding.value.reviewId
  } else if (binding.value.asin) {
    el.innerHTML = binding.value.asin
  } else if (binding.value.searchKeywords) {
    el.innerHTML = binding.value.searchKeywords
  } else if (binding.value.sellerId) {
    el.innerHTML = binding.value.shopName || binding.value.sellerId
  }
  el.onclick = function(e) {
    e.stopPropagation()
    amazonHref(binding.value)
  }
  // el.removeEventListener('click', function() { amazonHref(binding.value) })
  // el.addEventListener('click', function() { amazonHref(binding.value) })
}
const amazonHref = async(binding) => {
  const amazonCountry = await store.dispatch('map/getAmazonCountry')
  if (amazonCountry) {
    let url
    if (amazonCountry[binding.code]) {
      if (binding.reviewId) {
        url = `${amazonCountry[binding.code].mwsApi.domain}gp/customer-reviews/${binding.reviewId}`
      } else if (binding.asin) {
        if (binding.goAmazon) {
          url = `${amazonCountry[binding.code].mwsApi.domain}dp/${binding.asin}`
        } else {
          url = resolveVueRouter({
            name: 'bi-operationAnalyse',
            query: {
              type: 'analyse',
              asin: binding.asin,
              countryCode: binding.code,
              ...(binding.otherData || {})
            },
          })
        }
      } else if (binding.searchKeywords) {
        url = `${amazonCountry[binding.code].mwsApi.domain}s?k=${binding.searchKeywords}`
      } else if (binding.sellerId) {
        url = `${amazonCountry[binding.code].mwsApi.domain}sp?seller=${binding.sellerId}`
      }
      // app 外部跳转
      if (binding.noBlank) location.href = url
      else window.open(url, '_blank')
    }
  }
}
export default {
  inserted: updateInner,
  componentUpdated: updateInner,
  // 指令与元素解绑时
  unbind(el, binding) {
    // el.removeEventListener('click', function() { amazonHref(binding.value) })
  }
}
